<!-- https://stackblitz.com/edit/angular-1yr75s?file=src%2Fapp%2Fapp.component.ts-->
<div  class="container stdTheme"  >
    <div *ngIf="!dataImgLoaded" class="flex-row row" style="margin: 0px">
        <div class="container-fluid d-flex justify-content-center" >
            <mat-progress-bar 
                mode="indeterminate"
                style="margin-left: 30px;">
            </mat-progress-bar>
        </div>
    </div>

    <div class="row image-container">
      
            <!--<img [src]="imageToShow" alt="{{titleReport}}" *ngIf="!isImageLoading">-->
            <img class="img-fluid" [src]="imageToShow  | safeHtml: 'resourceUrl' " alt="{{titleReport}}">

    </div>
    
</div>